module.exports = __webpack_public_path__ + "static/img/our-awards_2.96aa44b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/our-awards_2.png
// module id = /rWq
// module chunks = 0